export const faq = [
  {
    id: 1,
    question: "What services does Solaire training co. offer?",
    answer:
      "We provide customised training programs, strategic consulting, leadership development, and operational efficiency solutions to help businesses and individuals achieve sustainable growth.",
  },
  {
    id: 2,
    question: "How can I book a consultation?",
    answer:
      "You can easily book a consultation through our website by filling out the 'Contact Us' form or by reaching out to us directly via call or email",
  },
  {
    id: 3,
    question: "Do you offer remote or virtual training sessions?",
    answer:
      "Yes! We offer both in-person and virtual training sessions to accommodate your needs and ensure flexibility, regardless of your location.",
  },
  {
    id: 4,
    question:
      "Can your consulting services be tailored to specific industries?",
    answer:
      "Absolutely. Our team works closely with clients to develop industry-specific strategies that address unique challenges and unlock new opportunities.",
  },
  {
    id: 5,
    question: "What is your typical response time for inquiries?",
    answer:
      "We strive to respond to all inquiries within 24-48 hours, ensuring that you receive the support you need as quickly as possible.",
  },
];
